/** @format */

import React, { useState, useEffect } from 'react'
import useGlobalData from 'src/hooks/useGlobalData'
import styled from 'styled-components'
import { _$, Breadcrumb, BreadcrumbItem, Select, Option } from '@king-design/react'
import { useHistory } from 'react-router'

interface MonitorCloudCrumbProps {
  className?: string
  pageType: 'list' | 'chart'
  productType: number
  curProduct?: any // 图表页面需要传入当前产品（link title）
  rightComponent?: React.ReactElement
  children?: React.ReactElement
}

const MonitorCloudCrumb: React.FC<MonitorCloudCrumbProps> = ({
  className,
  productType,
  curProduct,
  children,
  pageType,
  rightComponent
}) => {
  const history = useHistory()
  const productSubMenu = useGlobalData('productSubMenu')
  const [productGroup, setProductGroup] = useState<any>()

  useEffect(() => {
    if (productSubMenu?.length) {
      const find_product = productSubMenu.find(item => {
        return item.subMenus.find(menu => menu.productType === productType)
      })
      if (find_product) {
        setProductGroup(find_product)
      }
    }
  }, [productSubMenu, productType])

  return (
    <div className={className}>
      {productSubMenu?.length && productGroup ? (
        <p className="breadcrumb-text">
          <Breadcrumb slotSeparator="/">
            <BreadcrumbItem to="/monitor/menu">{_$('云产品监控')}</BreadcrumbItem>
            {pageType === 'list' ? (
              <>
                <BreadcrumbItem className="product_group">
                  <Select
                    inline
                    searchable
                    size="large"
                    value={productGroup.productType}
                    container=".product_group"
                    onChangeValue={val => {
                      const find_group = productSubMenu.find(item => item.productType === val)
                      if (find_group?.subMenus?.[0]?.link) {
                        history.push(find_group?.subMenus?.[0]?.link)
                      }
                    }}
                  >
                    {productSubMenu.map(({ productType, title }) => {
                      return (
                        <Option key={productType} value={productType}>
                          {title}
                        </Option>
                      )
                    })}
                  </Select>
                </BreadcrumbItem>
                <BreadcrumbItem className="product_item">
                  <Select
                    inline
                    value={productType}
                    searchable
                    size="large"
                    onChangeValue={val => {
                      const find_product = productGroup.subMenus.find(item => {
                        return item.productType === val
                      })
                      if (find_product?.link) {
                        history.push(find_product?.link)
                      }
                    }}
                  >
                    {productGroup.subMenus.map(({ productType, title }) => {
                      return (
                        <Option key={productType} value={productType}>
                          {title}
                        </Option>
                      )
                    })}
                  </Select>
                </BreadcrumbItem>
              </>
            ) : (
              <>
                <BreadcrumbItem to="/monitor/menu">{_$(productGroup.title)}</BreadcrumbItem>
                <BreadcrumbItem to={curProduct.link}>{_$(curProduct.title)}</BreadcrumbItem>
              </>
            )}

            {children || ''}
          </Breadcrumb>
        </p>
      ) : null}
      {rightComponent ? <div className="kfc-breadcrumb-right">{rightComponent}</div> : ''}
    </div>
  )
}

export default styled(MonitorCloudCrumb)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  flex-wrap: wrap;
  line-height: 50px;
  .breadcrumb-text {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .ion-chevron-left {
      margin-right: 8px;
    }
    .product_group,
    .product_item {
      .k-select-menu {
        width: 220px;
      }
    }
  }
  .crumbItem {
    display: inline-block;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #262626;
  }
`
